// extracted by mini-css-extract-plugin
export default {"aboutPageContainer":"AboutPage_aboutPageContainer__qLcSP"};